import React, { useState } from 'react'
import { useHistory, useParams, useLocation } from "react-router-dom";

import Header from '../../components/header/index.js'
import Footer from '../../components/footer/index.js'

import RegisterTable from '../../components/registerTable/index.js'
import RegisterFile from '../../components/registerFile/index.js'


// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const Register = () => {

    let history = useHistory();
    let query   = useQuery();

    const typeRegister  = query.get("typeRegister")
    const env           = query.get("env")
    const layer         = query.get("layer")

    const handleBack = () => {
        history.push("/pre-ingestion");
    }

    return (
        <div>
            <Header />

            {typeRegister === "Register Table" ? <RegisterTable env={env} layer={layer} handleBack={handleBack} /> : null}
            {typeRegister === "Register File" ? <RegisterFile env={env} layer={layer} handleBack={handleBack} /> : null}

            <Footer />
        </div>
    );
}

export default Register;
